import { Command } from '@nextforce/api'
import { t } from 'app/i18l'
import { NonAvailabilityDetailsScreenProps } from 'home/stack/types'
import { useNonAvailabilityList } from 'non_availability/queries/list'
import { usePerformNonAvailabilityAction } from 'non_availability/queries/perform_action'
import { StoreUserNonAvailability } from 'non_availability/queries/types'
import { buildNonAvailabilityMutationAction } from 'non_availability/utils'
import { useCallback, useLayoutEffect } from 'react'
import { errorAlert } from 'shared/alerts'
import { StatusBoundary } from 'shared/components/status_boundary'
import { showHeaderTitle } from 'shared/header/header_title'
import { NonAvailabilityDetailsView } from './views'

export function NonAvailabilityDetailsScreen({
  navigation,
  route,
}: NonAvailabilityDetailsScreenProps) {
  const { requestId, storeId } = route.params
  const nonAvailabilityListQuery = useNonAvailabilityList(storeId)
  const nonAvailabilityMutation = usePerformNonAvailabilityAction()

  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('availabilityDetails'))
  }, [navigation])

  const onCommandButtonPress = useCallback(
    async (command: Command, nonAvailability: StoreUserNonAvailability) => {
      if (command.type === 'action') {
        try {
          const mutationAction = buildNonAvailabilityMutationAction(
            nonAvailability,
            command.action
          )
          await nonAvailabilityMutation.mutateAsync(mutationAction)
        } catch (err: any) {
          console.log(err)
          errorAlert(
            err,
            t('couldNotApproveRejectAvailabilityRequestErrorTitle')
          )
        }
      }
    },
    [nonAvailabilityMutation]
  )

  return (
    <StatusBoundary
      isLoading={nonAvailabilityListQuery.isLoading}
      error={nonAvailabilityListQuery.error}
    >
      <NonAvailabilityDetailsView
        nonAvailabilities={nonAvailabilityListQuery.data?.nonAvailabilityList}
        requestId={requestId}
        onCommandButtonPress={onCommandButtonPress}
      />
    </StatusBoundary>
  )
}
